/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import DataTable from "../../Components/DataTable/DataTable";
import { alertBox } from "../../Components/Functions";
import Layout from "../../Components/Layout";
import {
	updateAppointsFilters,
	updateRecords,
} from "../../Redux/MyAppointments/actions";
import { openPanel } from "../../Redux/Panels/RightPanel/actions";
import Api from "../../Server/Api";
import { ACCESS_PERMISSIONS as permissions } from "../../Constants/main";

const api = new Api();

export const PermissionItem = (props) => {
	const updatePermission = (id, status, permission_type) => {
		if (id) {
			api.put({
				endpoint: `permission/${id}/update_permission_request/`,
				data: { status },
			});
		} else {
			api.post({
				endpoint: `permission/grant_permission/`,
				data: {
					doctor_id: props.data.id,
					permission_type,
					status,
				},
			});
		}
	};

	const deleteMe = (id) => {
		api.del({ endpoint: `permission/${id}/delete_all_permission/` })
		.then(() => {
			props?.refreshTable();
		});
	};

	return (
		<>
			<td style={{ 
					fontWeight: "bold", 
					display: "flex",
					alignItems: "center",
				}}>
				<div className="h-avatar is-medium mr-5">
					<img
						className="avatar"
						src={
							props?.data?.image ||
							require("../../assets/images/placeholder.png").default
						}
						alt="Profile"
					/>
				</div>
				<div>
					<span className="item-name dark-inverted" data-filter-match>
						{props?.data?.name}
						<br />
						<small>@{props?.data?.username}</small>
					</span>
				</div>
			</td>
			{permissions.map((p) => {
				const permission = props?.data?.permissions?.find((e) => e.type === p);
				return (
					<td key={`${p}-${props?.data?.id}`}>
						<div className="control">
							<label className="form-switch is-primary">
								<input
									type="checkbox"
									className="is-switch"
									defaultChecked={permission?.status}
									onChange={(e) =>
										updatePermission(permission?.id, e.target.checked, p)
									}
								/>
								<i />
							</label>
						</div>
					</td>
				);
			})}
			<td>
				<button
					className={`ml-2 button h-button is-danger is-pushed-mobile`}
					onClick={() => {
						alertBox({
							title: "Delete",
							message: "Are you sure you want to delete all permissions for the selected doctor?",
							btnCallback: "Yes, Delete",
							callback: () => deleteMe(props?.data?.id),
						});
					}}
				>
					Delete
				</button>
			</td>
		</>
	);
};


const ManagePermissions = (props) => {
	const [tableParams, setTableParams] = React.useState({});

	const refreshTable = () => {
		setTableParams({ ...tableParams, added: (tableParams?.added || 0) + 1 });
	};

	return (
		<Layout
			pageContentClass={"tabs-wrapper is-slider is-squared is-inverted"}
			title={"Manage Permissions"}
		>
			<div className="page-content-inner xnobg-table">
				<div className="flex-list-wrapper flex-list-v1">
					<div className="flex-table">
						{/*Table header*/}

						<DataTable
							header={[
								{ name: "Doctor" },
								...permissions.map((p) => {
									return { name: p };
								}),
								{ name: "Action" },
							]}
							options={{
								allowRemove: false,
								allowBulkSelect: false,
								disableToolBar: false,
								disablePagination: false,
								removeEndPoint: "",
								endpoint: {
									url: `/permission/manage_my_permissions/`,
									params: tableParams,
								},
							}}
							renderItem={(e) => <PermissionItem data={e} parent={props} refreshTable={refreshTable} />}
						/>
					</div>
				</div>
			</div>
		</Layout>
	);
};

const mapStateToProps = ({ myappointments }) => {
	return { myappointments };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateAppointsFilters: (e) => dispatch(updateAppointsFilters(e)),
		updateRecords: (e) => dispatch(updateRecords(e)),
		openPanel: (e) => dispatch(openPanel(e)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(ManagePermissions); /* eslint-disable jsx-a11y/anchor-is-valid */
